

import { Component, Input, OnInit } from '@angular/core';

export interface PowerInfo {
  name?: string;
  primary?: number;
  secondary?: number[];
}

@Component({
  selector: 'app-gauges-owner-component',
  templateUrl: './gauges-owner.component.html',
  styleUrls: ['./gauges-owner.component.css']
})
export class GaugesOwnerComponent implements OnInit {

  @Input() nomeAzienda: string;

  @Input() powerInfo: any[];
  
  // Dati per il gauge nel formato PowerInfo
  currentValue: PowerInfo;

  suddividiInCentinaia() {
  const risultato = [];
  for (let i = 100; i <= this.maxValue; i += 100) {
    risultato.push(i);
  }
  return risultato;
}
  

  constructor() { }

  ngOnInit() {
    // Imposta il primo valore come default
    console.log(this.powerInfo);

    this.currentValue = (this.powerInfo as unknown as PowerInfo);

    this.currentValue.secondary = this.suddividiInCentinaia();
  }


  get maxValue() {
    if(this.currentValue)
      return  this.currentValue.primary +  1024;
  }

  // Personalizza le etichette della scala
  customizeText = (arg: any) => {
    return arg.value + ' MB';
  };

  // Personalizza il tooltip
  // customizeTooltip = (arg: any) => {
  //   let result = `<div><div class="tooltip-header">${this.currentValue.name}</div>`;
  //   result += `<div class="tooltip-body"><div class="series-name">Consumo: <span class="value-text">${arg.value} MB</span></div>`;
    
  //   if (arg.value === this.currentValue.primary) {
  //     result += '<div class="series-name">Principale</div>';
  //   } else {
  //     const index = this.currentValue.secondary.indexOf(arg.value);
  //     if (index !== -1) {
  //       result += `<div class="series-name">Soglia ${index + 1}</div>`;
  //     }
  //   }
    
  //   result += '</div></div>';
  //   return { html: result };
  // };

  getValueText() {
    return `${this.currentValue} MB`;
  }


  // Helper per determinare il colore in base al consumo
  getStatusColor() {
    if(!this.currentValue)
      return '#ffc107'; // Giallo - Attenzione  

    if (this.currentValue.primary <= 100) return '#28a745'; // Verde - OK
    if (this.currentValue.primary <= 300) return '#ffc107'; // Giallo - Attenzione  
    return '#dc3545'; // Rosso - Critico
  }

  getStatusText() {
    if(!this.currentValue)
      return 'Attenzione'; 

    if (this.currentValue.primary <= 100) return 'Normale';
    if (this.currentValue.primary <= 300) return 'Attenzione';
    return 'Critico';
  }
}